import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { Trophy, Laptop, Music } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ActivitiesPage() {
  const activities = [
    {
      icon: Trophy,
      title: 'Sports',
      items: ['Football', 'Cricket', 'Volleyball', 'Basketball', 'Athletics', 'Yoga'],
      color: 'bg-blue-100 text-blue-700'
    },
    {
      icon: Laptop,
      title: 'Computer & Technology',
      items: ['Basic Computer', 'Coding Classes', 'Digital Literacy', 'Smart Classrooms'],
      color: 'bg-green-100 text-green-700',
      link: '/digital-coding-program'   // ✅ ADD THIS
    },
    {
      icon: Music,
      title: 'Cultural Activities',
      items: ['Dance', 'Music', 'Drama', 'Art & Craft', 'Festivals', 'Annual Function'],
      color: 'bg-purple-100 text-purple-700'
    }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">School Activities</h1>
          <p className="text-xl text-blue-100">Holistic development through diverse activities</p>
        </div>
      </section>
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {activities.map((activity, i) => {
              const CardContent = (
                <GlassCard key={i} className="cursor-pointer hover:shadow-xl transition">
                  <div className={`w-16 h-16 ${activity.color} rounded-2xl flex items-center justify-center mb-4`}>
                    <activity.icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-2xl font-bold text-blue-900 mb-4">
                    {activity.title}
                  </h3>
                  <ul className="space-y-2">
                    {activity.items.map((item, j) => (
                      <li key={j} className="text-slate-600 flex items-center">
                        <span className="w-2 h-2 bg-amber-500 rounded-full mr-3"></span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </GlassCard>
              );

              return activity.link ? (
                <Link key={i} to={activity.link}>
                  {CardContent}
                </Link>
              ) : (
                CardContent
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}
